export class SessionUserAccountMismatchError extends Error {
    unauthorized = true;
    constructor(message) {
        super(message || 'Cuenta de usuario de sesión no coincide con el usuario actual');
        this.name = 'SessionUserAccountMismatchError';
    }
}
//# sourceMappingURL=session_user_account_mismatch_error.js.map